import { useState } from 'react';
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { Smile } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import { _Label } from '@common-models/label';
import { labelActions } from '@common-reducers/labels-reducer';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import LucideIconPicker from './lucide-icon-picker';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";

type Props = {
    label: _Label
    disabled?: boolean
}

export default function EmojiPickerPopper({ label, disabled }: Props) {
    const dispatch = useAppDispatch()
    const [open, setOpen] = useState(false);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const SelectedIcon = label.icon && (LucideIcons as any)[label.icon] ? (LucideIcons as any)[label.icon] : null;

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div className="flex items-center">
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        disabled={disabled}
                        className={cn(
                            "h-[44px] w-[50px] rounded-l-md rounded-r-none border-r border-gray-200 text-gray-500 hover:text-[#546eff] hover:bg-transparent",
                            disabled && "opacity-50"
                        )}
                    >
                        {SelectedIcon ? (
                            <SelectedIcon size={20} />
                        ) : label.icon ? (
                            <span className="text-xl">{label.icon}</span>
                        ) : (
                            <Smile size={20} />
                        )}
                    </Button>
                </div>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 " align="start" zIndex={11111}>
                <LucideIconPicker
                    currentIcon={label.icon}
                    onSelect={(iconName) => {
                        dispatch(labelActions.setLabel({ ...label, icon: iconName }))
                        setOpen(false)
                    }}
                />
            </PopoverContent>
        </Popover>
    )
}